import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useParams } from 'react-router-dom'
export const WorkOrderLeftSidebar = ({candidates, total, currentPage, setCleanerId}) => {
  const [activeId, setActiveId] = useState('')
  const params = useParams()
  useEffect(()=> {
   if(candidates?.length>0){
setActiveId(candidates[0]?.id)
   }

  },[])

  const currentIndex = ()=>{
    return candidates.findIndex(candidate => candidate.id === activeId) === -1 ? 0 : (candidates.findIndex(candidate => candidate.id === activeId)+1)
  }


  return (
    <>
    <div className='border-neutral-200 border-b py-4'>
    <h2 className='px-4 text-2xl  text-[#595959]'><FormattedMessage id='RECRUITER.POSTED.JOB.CANDIDATES.TITLE' defaultMessage='Candidates' /></h2>
    <p className='px-4 text-xs text-[#595959]'><FormattedMessage id='RECRUITER.CANDIDATES.PAGEINATION.TITLE' defaultMessage='Candidate {activeNumber} of {totalNumber}' values={{activeNumber:currentIndex(), totalNumber:total||0}}/></p>
    </div>
   { candidates?.map((data, index)=> (

    <div onClick={()=> {setCleanerId(data?.cleaner_id?._id); setActiveId(data?.id)}} key={index} className={`border-neutral-200 border-b py-4 cursor-pointer ${data?.id=== activeId ? 'bg-[#FAF9F8]': ''}`}>
    <h2 className='px-4 text-base '>{data?.cleaner_id?.first_name} {data?.cleaner_id?.last_name}</h2>
    <p className='px-4 text-xs text-[#595959]'>{data?.cleaner_id?.address?.address_line_1} {data?.cleaner_id?.address?.address_line_2}</p>
    </div>
    )) }
  </>)

}
